
import { bgColors } from "../../../utils/bgColor";
import mapboxgl from 'mapbox-gl';
import { tilerootpath } from "../../../api_servcies/apirootpath";

const LineColor = bgColors.grey_300
const adminboundryurl = `${tilerootpath}/boundrylayer`
const adminBoundry = (map) => {
  
  // Find the index of the first symbol layer in the map style.

  // console.log(firstSymbolId)

      const popup = new mapboxgl.Popup({
            offset: -10,
            closeButton: false,
            // closeOnClick: false,
            closeOnMove: true,
            maxWidth: "auto"
      })
       map.addSource('boundrylayer', {
            type: 'vector',
            "tiles": [`${adminboundryurl}/{z}/{x}/{y}.mvt`],
            "tolerance": 1000,
            // 'maxzoom': 8,
       });
        map.addLayer({
              'id': 'state_boundry',
              'type': 'fill',
              'source': 'boundrylayer',
              'source-layer': 'state_boundry',
              'minzoom':4,
              'layout': {
        
                'visibility': 'visible',
              },
              'paint': {
                  'fill-outline-color':bgColors.grey_300,
                  'fill-color': 'transparent',
                  }
        }
        );
  
        // map.addLayer({
        //   'id': 'state_boundry_outline',
        //   'type': 'line',
        //   'source': 'boundrylayer',
        //   'source-layer': 'state_boundry',
        //   'minzoom':4,
        //   'layout': {
        //   // Make the layer visible by default.
        //   'visibility': 'visible',
        //   },
        //   'paint': {
        //   'line-color': LineColor,
        //   'line-width': 1
        //   }
        // });
  
    map.addLayer(
        {
          'id': 'state_boundry_highlighted',
          // 'type': 'fill',
          'type': 'line',
          'source': 'boundrylayer',
          'source-layer': 'state_boundry',
          'minzoom':4,
          'paint': {
            'line-color': bgColors.yellow_500,
            'line-width': 2
            // 'fill-outline-color': bgColors.green_500,
            // 'fill-color': bgColors.grey_500,
            // 'fill-opacity': 0.3
          },
          'filter': ['in', 'id', '']
          },
        // // Place polygons under labels.
        // 'india_village-label'
      );


      map.addLayer({
        'id': 'district_boundry',
        'type': 'fill',
        'source': 'boundrylayer',
        'source-layer': 'district_boundry',
        'minzoom': 7,
        'layout': {
  
          'visibility': 'visible',
        },
        'paint': {
            'fill-outline-color':LineColor,
            'fill-color': 'transparent',
            }
  });

  // map.addLayer({
  //   'id': 'district_boundry_outline',
  //   'type': 'line',
  //   'source': 'boundrylayer',
  //   'source-layer': 'district_boundry',
  //   'minzoom': 7,
  //   'layout': {
  //   // Make the layer visible by default.
  //   'visibility': 'visible',
  //   },
  //   'paint': {
  //   'line-color': LineColor,
  //   'line-width': 1
  //   }
  // });

map.addLayer(
  {
    'id': 'district_boundry_highlighted',
    // 'type': 'fill',
    'type': 'line',
    'source': 'boundrylayer',
    'source-layer': 'district_boundry',
    'minzoom': 7,
    'paint': {
      'line-color': bgColors.yellow_500,
      'line-width': 2
      // 'fill-outline-color': bgColors.green_500,
      // 'fill-color': bgColors.grey_500,
      // 'fill-opacity': 0.3
    },
    'filter': ['in', 'id', '']
    },
  // // Place polygons under labels.
  // 'india_village-label'
);


map.addLayer({
  'id': 'subdistrict_boundry',
  'type': 'fill',
  'source': 'boundrylayer',
  'source-layer': 'subdistrict_boundry',
  'minzoom': 10,
  'layout': {
    'visibility': 'visible',
  },
  'paint': {
      'fill-outline-color':LineColor,
      'fill-color': 'transparent',
      }
});

// map.addLayer({
// 'id': 'subdistrict_boundry_outline',
// 'type': 'line',
// 'source': 'boundrylayer',
// 'source-layer': 'subdistrict_boundry',
// 'minzoom': 10,
// 'layout': {
// // Make the layer visible by default.
// 'visibility': 'visible',
// },
// 'paint': {
// 'line-color': LineColor,
// 'line-width': 1
// }
// });

map.addLayer(
{
'id': 'subdistrict_boundry_highlighted',
// 'type': 'fill',
'type': 'line',
'source': 'boundrylayer',
'source-layer': 'subdistrict_boundry',
'minzoom': 10,
'paint': {
  'line-color': bgColors.yellow_500,
  'line-width': 2

// 'fill-outline-color': bgColors.green_500,
// 'fill-color': bgColors.grey_500,
// 'fill-opacity': 0.3
},
'filter': ['in', 'id', '']
},
// // Place polygons under labels.
// 'india_village-label'
);



map.addLayer({
  'id': 'village_boundry',
  'type': 'fill',
  'source': 'boundrylayer',
  'source-layer': 'village_boundry',
  'minzoom': 12,
  'layout': {

    'visibility': 'visible',
  },
  'paint': {
      'fill-outline-color':LineColor,
      'fill-color': 'transparent',
      // 'line-width': 1
      }
}

);

// map.addLayer({
// 'id': 'village_boundry_outline',
// 'type': 'line',
// 'source': 'boundrylayer',
// 'source-layer': 'village_boundry',
// 'minzoom': 12,
// 'layout': {
// // Make the layer visible by default.
// 'visibility': 'visible',
// },
// 'paint': {
// 'line-color': LineColor,
// 'line-width': 1
// }
// });

map.addLayer(
{
'id': 'village_boundry_highlighted',
'type': 'line',
'source': 'boundrylayer',
'source-layer': 'village_boundry',
'minzoom': 12,
'paint': {
  'line-color': bgColors.yellow_500,
  'line-width': 2
// 'fill-outline-color': bgColors.green_500,
// 'fill-color': bgColors.green_500,
// 'fill-opacity': 0.3
},
'filter': ['in', 'id', '']
},
// // Place polygons under labels.
// 'india_village-label'
);


map.addLayer({
  'id': 'pincode',
  'type': 'fill',
  'source': 'boundrylayer',
  'source-layer': 'pincode',
  'minzoom': 9,
  'layout': {

    'visibility': 'visible',
  },
  'paint': {
      'fill-outline-color':LineColor,
      'fill-color': 'transparent',
      // 'line-width': 1
      }
}

);

// map.addLayer({
// 'id': 'village_boundry_outline',
// 'type': 'line',
// 'source': 'boundrylayer',
// 'source-layer': 'village_boundry',
// 'minzoom': 12,
// 'layout': {
// // Make the layer visible by default.
// 'visibility': 'visible',
// },
// 'paint': {
// 'line-color': LineColor,
// 'line-width': 1
// }
// });

map.addLayer(
{
'id': 'pincode_highlighted',
'type': 'line',
'source': 'boundrylayer',
'source-layer': 'pincode',
'minzoom': 9,
'paint': {
  'line-color': bgColors.yellow_500,
  'line-width': 2
// 'fill-outline-color': bgColors.green_500,
// 'fill-color': bgColors.green_500,
// 'fill-opacity': 0.3
},
'filter': ['in', 'id', '']
},
// // Place polygons under labels.
// 'india_village-label'
);
  
  

  map.on('click', (e) => {
    // Change the cursor style as a UI indicator.
            const bbox = [
                [e.point.x - 5, e.point.y - 5],
                [e.point.x + 5, e.point.y + 5]
                ];
            
            const selectedFeatures = map.queryRenderedFeatures(bbox, {
              layers: ['state_boundry','district_boundry', 'subdistrict_boundry', 'village_boundry','pincode']
            });
            // console.log(selectedFeatures)
          if (selectedFeatures !== undefined && selectedFeatures.length > 0 ) {
              map.setFilter('village_boundry_highlighted', [
              'in',
              'id',
            selectedFeatures[0].properties.id
              ]);
            }
            if (selectedFeatures !== undefined && selectedFeatures.length > 0 ) {
              map.setFilter('pincode_highlighted', [
              'in',
              'id',
            selectedFeatures[0].properties.id
              ]);
            }

            if (selectedFeatures !== undefined && selectedFeatures.length > 0 ) {
              map.setFilter('subdistrict_boundry_highlighted', [
              'in',
              'id',
            selectedFeatures[0].properties.id
              ]);
            }
            if (selectedFeatures !== undefined && selectedFeatures.length > 0 ) {
              map.setFilter('district_boundry_highlighted', [
              'in',
              'id',
            selectedFeatures[0].properties.id
              ]);
            }
            if (selectedFeatures !== undefined && selectedFeatures.length > 0 ) {
              map.setFilter('state_boundry_highlighted', [
              'in',
              'id',
            selectedFeatures[0].properties.id
              ]);
            }

            });

    
  
}

export default adminBoundry